import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{attrs:{"small":"","rounded":"","color":"primary","loading":_vm.loading,"disabled":!(_vm.has_done_form && !_vm.done_form_is_partial)},on:{"click":function($event){return _vm.submit()}}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }